import { CandidateData } from '$types/candidates';
import { useCallback } from 'react';
import { ReactComponent as Export } from '$icons/export.svg';

const ExportCandidatePositionData = ({
  candidatesData,
  positionId,
  disabled,
}: {
  candidatesData: CandidateData[];
  positionId: number;
  /** Set while candidates are loading, so a partial list isn't exported */
  disabled?: boolean;
}) => {
  const exportCandidates = useCallback(() => {
    const headers = [
      'Candidate Id',
      'Candidate URL',
      'Email',
      'Name',
      'Last Name',
      'Salary Range',
      'CV',
      'Video',
      'Reference',
    ].join(',');
    const csvContent = candidatesData.map((singleCandidate) => {
      const candidateData: string[] = [];
      /* Candidate Id */
      candidateData.push(`${singleCandidate.Id}`);
      /* Candidate URL */
      const candidatePath = `/simera-dashboard/positions/${positionId}/candidates/${singleCandidate.Id}`;
      const candidateUrl = new URL(candidatePath, window.location.origin);
      candidateData.push(candidateUrl.toString());
      /* Candidate Email */
      candidateData.push(`"${singleCandidate.User?.Email}"`);
      /* Candidate Name */
      candidateData.push(`"${singleCandidate.User?.FirstName}"`);
      /* Candidate Last Name */
      candidateData.push(`"${singleCandidate.User?.LastName}"`);
      /* Candidate Salary Range */
      if (
        !singleCandidate.CandidateJobInterest ||
        (!singleCandidate.CandidateJobInterest?.SalaryLowerBound &&
          !singleCandidate.CandidateJobInterest?.SalaryUpperBound)
      )
        candidateData.push('N/A');
      else
        candidateData.push(
          `${
            singleCandidate.CandidateJobInterest.SalaryLowerBound || 'N/A'
          } - ${singleCandidate.CandidateJobInterest.SalaryUpperBound || 'N/A'}`
        );
      /* CV */
      candidateData.push(singleCandidate.Curriculum?.Url ? 'TRUE' : 'FALSE');
      /* Video */
      candidateData.push(
        singleCandidate.AdditionalVideos &&
          singleCandidate.AdditionalVideos.length > 0
          ? 'TRUE'
          : 'FALSE'
      );
      /* Reference */
      candidateData.push(
        singleCandidate.Files &&
          singleCandidate.Files.length > 0 &&
          singleCandidate.Files.find(
            (singleFile) =>
              singleFile?.FileCategory?.CategoryName?.toLowerCase() ===
              'reference'
          )
          ? 'TRUE'
          : 'FALSE'
      );
      return candidateData.join(',');
    });

    const blob = new Blob([[headers, ...csvContent].join('\n')], {
      type: 'text/csv;charset=utf-8;',
    });

    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'Simera - Candidates.csv';

    link.click();

    URL.revokeObjectURL(blobUrl);
  }, [candidatesData, positionId]);

  return (
    <button
      type="button"
      className="bg-internal-main px-4 py-2 rounded-md disabled:opacity-50"
      title="Export"
      onClick={exportCandidates}
      disabled={disabled}
    >
      <Export className="fill-white w-5 rotate-180" />
    </button>
  );
};

ExportCandidatePositionData.defaultProps = {
  disabled: false,
};

export default ExportCandidatePositionData;
